import TranslatedMessage from "./TranslatedMessage";

const AnotherCity = (props) => {
  return (
    <>
      <p>
        <TranslatedMessage id="sections.anothercity.header" />
      </p>
      <div className="margin-top-48 margin-bottom-16">
        <a
          className="pd-btn pd-btn--outline"
          href="https://przyjazne-deklaracje.pl/"
        >
          <TranslatedMessage id="sections.anothercity.action.title" />
        </a>
      </div>
    </>
  );
};

export default AnotherCity;
